import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectNewVoicemail, selectSavedVoicemail, setNewVoicemail, setSavedVoicemail } from '../../../state/voicemail/voicemailSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* deleteVoicemailSaga(action) {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);
        const voicemail = action.payload;

        // API endpoint for retrieving voicemail (relative URL)
        const apiUrl = '?object=audio&action=delete';
        // Parameters for the API call
        const params = {
            format: 'json',
            owner: user,
            owner_domain: domain,
            type: voicemail.vmail_type,
            index: voicemail.filename,
            intArray: 'true',
        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        if (response.status === 202) {

            //Update the State
            if (voicemail.vmail_type === 'vmail/new') {
                const newVoicemails = yield select(selectNewVoicemail);
                const updatedNewVoicemails = newVoicemails.filter(vm => vm.index !== voicemail.index);
                yield put(setNewVoicemail(updatedNewVoicemails));
            } else {
                const savedVoicemails = yield select(selectSavedVoicemail);
                const updatedSavedVoicemails = savedVoicemails.filter(vm => vm.index !== voicemail.index);
                yield put(setSavedVoicemail(updatedSavedVoicemails));
            }

            yield put(showSnackbar({
                message: `Deleted the Voicemail`,
                severity: 'success'
            }));
        }

    }
    catch (error) {
        console.error(error);
        yield put(showSnackbar({
            message: `Error Deleting Voicemail`,
            severity: 'error'
        }));


    }
}